import { makeAutoObservable } from "mobx";

export class ErrorStore {
  error: string | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  setError(message: string) {
    this.error = message;
  }

  clearError() {
    this.error = null;
  }
}
